// extracted by mini-css-extract-plugin
module.exports =  {"variablesWrapper":"SettingsVariables__variables-wrapper"};